import { render, staticRenderFns } from "./DownloadStats.vue?vue&type=template&id=7a6c2880"
import script from "./DownloadStats.vue?vue&type=script&lang=js"
export * from "./DownloadStats.vue?vue&type=script&lang=js"
import style0 from "./DownloadStats.vue?vue&type=style&index=0&id=7a6c2880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports